export default __webpack_public_path__ + "static/media/Gry na przełamanie lodów_Sanja.6e223f63.pdf";